import { render, staticRenderFns } from "./gongwenDetailEdit.vue?vue&type=template&id=2517c443&scoped=true"
import script from "./gongwenDetailEdit.vue?vue&type=script&lang=js"
export * from "./gongwenDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./gongwenDetailEdit.vue?vue&type=style&index=0&id=2517c443&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2517c443",
  null
  
)

export default component.exports